import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Preloader = () => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
                width: "80vw",
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default Preloader;
